import { render, staticRenderFns } from "./RedirectHandde.vue?vue&type=template&id=c5669e74&scoped=true"
import script from "./RedirectHandde.vue?vue&type=script&lang=js"
export * from "./RedirectHandde.vue?vue&type=script&lang=js"
import style0 from "./RedirectHandde.vue?vue&type=style&index=0&id=c5669e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5669e74",
  null
  
)

export default component.exports